<template>
  <div>
    <div id="menusis" class="container mt-3">
      <div class="text-center mb-3">
        <span style="font-size: larger;">Menu</span>
      </div>

      <div class="row g-3">
        <div class="col-12 col-sm-6" v-for="item in menuItems" :key="item.id">
          <li class="list-group-item list-group-item-action border rounded p-0" @click.prevent="mtdabrirtela(item.tela)">
            <div class="card h-100" style="background-color: #212529;">
              <div class="container py-3">
                <div class="row">
                  <div class="col-2 text-center d-flex align-items-center justify-content-center">
                    <i :class="item.icone" style="font-size: 30px;"></i>
                  </div>
                  <div class="col-10">
                    <span class="tit-item-menu-ve d-block text-white">{{ item.titulo }}</span>
                    <small class="sub-tit-item-menu-ve text-muted d-block">{{ item.subtitulo }}</small>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </div>
      </div>
    </div>

    <div id="conteudocrud" class="container mt-4">
      <div v-if="cadreceitasdespesas">
        <cadreceitasdespesas />
      </div>
      <div v-if="cadcofrescontas">
        <cadcofrescontas />
      </div>
      <div v-if="cadcategorias">
        <cadcategorias />
      </div>
      <div v-if="cadmetas">
        <cadmetas />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import cadreceitasdespesas from './cruds/cadreceitasdespesas.vue'
import cadcofrescontas from './cruds/cadcofrescontas.vue'
import cadcategorias from './cruds/cadcategorias.vue'
import cadmetas from './cruds/cadmetas.vue'

export default {
  name: 'menusis',
  components: {
    cadcofrescontas,
    cadreceitasdespesas,
    cadcategorias,
    cadmetas
  },
  data() {
    return {
      cadreceitasdespesas: false,
      cadcofrescontas: false,
      cadmetas: false,
      cadcategorias: false,
      menuItems: [
        {
          id: 1,
          titulo: 'Cadastrar despesas/receitas',
          subtitulo: 'Cadastrar perfis de despesas e receitas, pré definidas',
          icone: 'bi bi-pie-chart-fill',
          tela: 'cadreceitasdespesas'
        },
        {
          id: 2,
          titulo: 'Cadastrar Cofres/contas',
          subtitulo: 'Cadastrar contas bancárias, carteiras digitais, fundos e etc.',
          icone: 'bi bi-bank',
          tela: 'cadcofrescontas'
        },
        {
          id: 3,
          titulo: 'Cadastrar Categorias',
          subtitulo: 'Aluguel, salário, cartão e etc',
          icone: 'bi bi-coin',
          tela: 'cadcategorias'
        },
        {
          id: 4,
          titulo: 'Cadastrar Objetivos',
          subtitulo: 'Cadastrar meta, guardar dinheiro; comprar casa; etc',
          icone: 'bi bi-rocket-takeoff-fill',
          tela: 'cadmetas'
        }
      ]
    }
  },
  methods: {
    mtdabrirtela(tela) {
      $('#menusis').hide();
      this.fechatelas();
      this[tela] = true;
      $('#conteudocrud').fadeIn(700);
    },
    fechatelas() {
      this.cadreceitasdespesas = false;
      this.cadcofrescontas = false;
      this.cadcategorias = false;
      this.cadmetas = false;
    }
  }
}
</script>

<style scoped>
.sub-tit-item-menu-ve {
  font-size: 0.75rem;
}

.tit-item-menu-ve {
  font-weight: 600;
  color: white;
}

@media (max-width: 576px) {
  .tit-item-menu-ve {
    font-size: 0.9rem;
  }
  .sub-tit-item-menu-ve {
    font-size: 0.65rem;
  }
}
</style>
